module.exports = __webpack_public_path__ + "static/media/conf.ac244046.png";